import { namespace } from '../index';
const _scopedState = state => state[namespace];

const email = state => _scopedState(state).email;

export default {
  email,
};
